import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to user management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  USER_MANAGEMENT: {
    path: `${baseRoutes.adminBaseRoutes}/user-management`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-users" />
      </span>
    ),
  },
  USER_DETAILS: {
    path: `${baseRoutes.adminBaseRoutes}/user-details`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-users" />
      </span>
    ),
  },
};

export default accessRoute;
